import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import {
  SummaryPanelComponent,
  SummaryPanelIconDirective,
  SummaryPanelContentDirective,
  SummaryPanelActionDirective, } from "./summary-panel.component";

@NgModule({
  imports: [ CommonModule ],
  declarations: [ SummaryPanelComponent, SummaryPanelIconDirective, SummaryPanelContentDirective, SummaryPanelActionDirective ],
  exports: [ SummaryPanelComponent, SummaryPanelIconDirective, SummaryPanelContentDirective, SummaryPanelActionDirective ]
})
export class SummaryPanelModule{}
